// Wolsey product page — mobile sticky ATC bar
//
// Shows a bottom-anchored bar (containing a duplicate ATC button + dynamic
// checkout button) when the inline ATC button has scrolled out of view.
// Mobile only (≤767px). Disables itself on desktop.

(function () {
  'use strict'

  const MOBILE_MAX = 767  // matches the rest of the theme's mobile breakpoint

  function init() {
    const bar = document.querySelector('[data-mobile-atc]')
    const inlineButton = document.querySelector('.c-product-page__add-to-cart-button')
    if (!bar || !inlineButton) return

    const mq = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)')
    let observer = null

    function show() {
      bar.hidden = false
      bar.setAttribute('aria-hidden', 'false')
      // Force a reflow before adding the visible class so the transition runs.
      // eslint-disable-next-line no-unused-expressions
      bar.offsetHeight
      bar.classList.add('is-visible')
    }

    function hide() {
      bar.classList.remove('is-visible')
      bar.setAttribute('aria-hidden', 'true')
      // After the transition, hide from layout too. 250ms matches the CSS.
      setTimeout(() => {
        if (!bar.classList.contains('is-visible')) bar.hidden = true
      }, 250)
    }

    function startObserving() {
      if (observer) return
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Inline ATC is visible → never show sticky bar
            hide()
            return
          }
          // Inline ATC is not visible. Two cases:
          //   (a) User scrolled past it (boundingClientRect.bottom < 0) → show
          //   (b) User hasn't reached it yet (boundingClientRect.top > 0) → hide
          // Previously we showed whenever !isIntersecting, which incorrectly
          // showed the bar on page load (when ATC was still below the fold).
          if (entry.boundingClientRect.bottom < 0) {
            show()
          } else {
            hide()
          }
        })
      }, {
        // Viewport-rooted; the bar only appears once the inline ATC button
        // has fully scrolled out of view.
        root: null,
        rootMargin: '0px',
        threshold: 0
      })
      observer.observe(inlineButton)
    }

    function stopObserving() {
      if (!observer) return
      observer.disconnect()
      observer = null
      bar.classList.remove('is-visible')
      bar.setAttribute('aria-hidden', 'true')
      bar.hidden = true
    }

    function handleMqChange() {
      if (mq.matches) startObserving()
      else stopObserving()
    }

    // Mirror the inline button's disabled state + label onto the sticky one.
    // The existing add-to-cart-form.min.js script toggles the inline button
    // when variants change availability; we keep the sticky one in sync.
    const stickyButton = bar.querySelector('[data-mobile-atc-button]')
    if (stickyButton) {
      const mirror = () => {
        stickyButton.disabled = inlineButton.disabled
        stickyButton.textContent = inlineButton.textContent
      }
      const buttonObserver = new MutationObserver(mirror)
      buttonObserver.observe(inlineButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        characterData: true,
        childList: true,
        subtree: true
      })
      mirror()
    }

    handleMqChange()
    if (mq.addEventListener) mq.addEventListener('change', handleMqChange)
    else if (mq.addListener) mq.addListener(handleMqChange)  // Safari < 14 fallback
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()